import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const selectedDashboardRoute: InvariantJiraRoute = {
	name: 'dashboard-selected',
	path: '/secure/Dashboard.jspa',
	query: ['selectPageId'],
};
